<template>

    <kt-modal
        :visible="recordVisible"
        :title="recordTitle"
        @dismiss="onDismiss()"
    >
        <template #body>
            <note-form v-model="record"></note-form>
        </template>
    
        <template #footer>
            <div class="kt-modal-actions">
                <button @click="onDismiss()" class="btn btn-outline-secondary">
                    <X :size="16" class="me-1" />Close
                </button>
                <button v-if="record.Id" @click="deleteRecord()" class="btn btn-outline-danger">
                    <Trash2 :size="16" class="me-1" />Delete
                </button>
                <button @click="saveRecord()" class="btn btn-primary">
                    <Save :size="16" class="me-1" />Save
                </button>
            </div>
        </template>
    </kt-modal>
        
    
    </template>
    
    
    <script setup>
    
    import { ref, onMounted, onUpdated } from "vue";
    import { useRoute, useRouter } from "vue-router";
    import { useAppStore } from "@/stores/AppStore";
    import Api from "@/services/Api";
    import Helper from "@/services/Helper";
    import Alert from "@/services/Alert";
    import noteForm from "@/components/Notes/NoteForm.vue";
    import KtModal from "@/components/UI/KtModal.vue";
    import { X, Trash2, Save } from 'lucide-vue-next';
    
    const route = useRoute();
    const router = useRouter();
    const appStore = useAppStore();
    const recordTitle = ref("Note Entry");
    const recordVisible = ref(true);
    
    const props = defineProps({
        taskId: {
            type: Number,
            default: 0
        },
        requestId: {
            type: Number,
            default: 0
        },
        workOrderId: {
            type: Number,
            default: 0
        },
        clientId: {
            type: Number,
            default: 0
        },
        embedded: {
            type: Boolean,
            default: false
        }
    });
    
    const emit = defineEmits(["cancel", "saved"]);
    
    const newRecord = () =>
    {
        return {
            UserId: "",
            ClientId: "",
            RequestId: "",
            WorkOrderId: "",
            DateTaken: "",
            Note: ""
        };
    };
    
    const record = ref(newRecord());
    
    const saveRecord = async () =>
    {
        try {
            let pay = record.value;

            if (pay.DateTaken) {
                pay.DateTaken = new Date(pay.DateTaken);
            }

            await Api.saveNote(pay);

            if (props.embedded) {
                emit("saved");
            } else {
                router.back();
            }
        } catch (error) {
            console.error("Save failed:", error);
        }
    };
    
    const deleteRecord = async () =>
    {
        Alert.notify({
            text: "Deletion has been disabled"
        });
    };
    
    
    const onDismiss = () =>
    {
        if (props.embedded) {
            emit("cancel");
        } else {
            router.back();
        }
    };
    
    onMounted(async () =>
    {
        if (props.embedded && (props.requestId || props.workOrderId)) {
            // In embedded mode, create a new note for the request or workorder
            let newRec = newRecord();
            newRec.TaskId = props.taskId;
            
            // For Request-based clocks, use WorkOrderId; for Job-based, use RequestId
            if (props.workOrderId) {
                newRec.WorkOrderId = props.workOrderId;
            } else {
                newRec.RequestId = props.requestId;
            }
            
            newRec.ClientId = props.clientId;
            newRec.UserId = appStore.account?.user?.UserId;
            record.value = newRec;
        } else {
            // Original routing-based logic
            switch (route.params.id)
            {
                case "new":
                    record.value = newRecord();
                    break;
        
                default:
        
                    let rec = await Api.loadNote(route.params.id);

                    /* fix any elements
                    if (rec.DateTaken) {
                        rec.DateTaken = new Date(rec.DateTaken + "Z");
                        rec.DateTaken = Helper.dateToInput(rec.DateTaken);
                    }
                        */

                    record.value = rec;
                    break;
            }
        }
    });
    
    </script>